import { IconType, IconSize } from '@sidecar-components/atoms/Icon'
import { Sentiment } from '@sidecar-components/types'

export enum LinkType {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
  CONTACT = 'contact',
}

export interface LinkProps {
  children?: any
  className?: string
  disabled?: boolean
  icon?: string
  iconPosition?: 'before' | 'after'
  iconType?: IconType | undefined
  iconSize?: IconSize
  id?: string
  onClick?: any
  path?: any
  sentiment?: Sentiment.DEFAULT | Sentiment.BRAND
  type?: LinkType
  testId?: string
  tooltip?: any
  target?: string
  removeStyles?: boolean
}
